var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.state == 'one')?_c('DigitalDownloadStep1',{attrs:{"events":_vm.events},on:{"submit":_vm.submitStepOne}}):_vm._e(),(_vm.state == 'redirecting')?_c('finished',{attrs:{"name":_vm.firstname(_vm.personalDetails.name),"url":_vm.url}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }